import api from "./api";

export const goldTradeHistoryAPI = {
  async getOrders({ page = 1, limit = 10, orderType, startDate, endDate } = {}) {
    const params = { page, limit };
    if (orderType) params.orderType = orderType;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const res = await api.get("/gold/orders", { params });
    return res.data;
  },
};
